var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"sessions-view",attrs:{"align":'start',"color":"#f5f5f5","fluid":""}},[_c('v-row',[_c('wrapper',[_c('router-view',{staticClass:"view filters-view",attrs:{"name":"filters"}})],1)],1),_c('v-row',[_c('wrapper',[_c('router-view',{staticClass:"view scrolled-max-h sessions-list"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }